module.exports = __webpack_public_path__ + "static/styxcalligraphy-47631a59e9c56ee63f30a1afd6fb778b.jpg";